import { Stack } from "@mui/material";
import { memo } from "react";
import TopMedScheduleItem from "./TopMedScheduleItem";
import { ITopMedScheduleListProps } from "./models";

const TopMedScheduleList: React.FC<ITopMedScheduleListProps> = ({
  data,
  onRefresh,
}) => {
  return (
    <Stack gap={1} mt={1}>
      {data.map((s) => (
        <TopMedScheduleItem data={s} key={s.hash} onRefresh={onRefresh} />
      ))}
    </Stack>
  );
};

export default memo(TopMedScheduleList);
